import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';

/**
 * Info icon explaining what a figure counts. Inline, so a wrapping heading keeps
 * the icon after its last word.
 */
export const InfoTip: React.FC<{ label: string; text: string }> = ({ label, text }) => (
  <Tooltip title={text}>
    {/* role makes the aria-label count; tabIndex lets keyboard and touch users open the tooltip. */}
    <Box
      component="span"
      role="img"
      tabIndex={0}
      aria-label={`${label}: ${text}`}
      sx={{ display: 'inline-flex', verticalAlign: 'middle', ml: 0.5 }}
    >
      <InfoIcon sx={{ fontSize: 15, color: 'text.disabled' }} />
    </Box>
  </Tooltip>
);
